// extracted by mini-css-extract-plugin
module.exports = {"scoreWrp":"styles_scoreWrp__3vps2","label":"styles_label__zoe0m","score":"styles_score__1wDCf"};